module.exports = "/static/media/chairman_Icon.2f725b0d.svg";